import { useState } from "react";
import { GICTransaction } from "../models/GICTransaction"
import { Button, DialogActions, DialogTitle, TextField } from "@mui/material";
import { TransactionType } from "../shared/Consts";
import { useDialog } from "../libs/dialog/DialogProvider";
import usePortfolio from "../hooks/PortfolioProvider";
import { useSnackbar } from "../libs/dialog/SnackbarProvider";
import PortAccount from "../models/PortAccount";
import EvalText from "../components/EvalText";

export default function Redeem(props:{trans:GICTransaction,reinvest?:boolean}) {
    const {trans} = props;
    const [amount,setAmount] = useState<string>( trans.coupon.toFixed(3) )
    const [error,setError] = useState<boolean>(false)
    const {closeDialog} = useDialog()
    const {setSnackbar} = useSnackbar()
    const {portfolio} = usePortfolio()
    const account = PortAccount.i

    const submit = async () => {
        const quantity = parseFloat(amount);
        if (quantity>0) {}
        else return setError(true)

        try {
            const updateCash = !props.reinvest
    
            const div = trans.clone() as GICTransaction;
            div.price = 1;
            div.type = TransactionType.dividend;
            div.quantity = quantity;
            div.date = new Date()
            div.note += " Interest";
            div._id = ""
    
            await account.update(portfolio, div, updateCash, 0)
    
            const redeem = trans.clone() as GICTransaction;
            redeem.price = 1;
            redeem.date = new Date();
            redeem._id = ""
            if (props.reinvest){
                redeem.type = TransactionType.reinvest;
                redeem.quantity = quantity;
                redeem.note += " Reinvest";
            }else{
                redeem.type = TransactionType.buy;
                redeem.quantity = -trans.principal;
                redeem.note += " Redeem"; 
            }
            await account.update(portfolio, redeem, updateCash, 0);
            closeDialog()
        }catch(e){
            setSnackbar(e)
        }
    }
    const title = (props.reinvest ? "Reinvest" : "Redeem") + " " + trans.holding.id
    return <>
        <DialogTitle>{title}</DialogTitle>
        <div className="content">
            <EvalText error={error} label="amount" variant="standard" value={amount} onEval={val=>setAmount(val)} onChange={e => setAmount(e.target.value)}/>
        </div>
        <DialogActions>
            <Button onClick={submit}>Submit</Button>
        </DialogActions>
    </>
}